const recipesVideoData = [
  {
    youtubeLink: "8csKyfW-Ak4",
  },
  {
    youtubeLink: "uNxFvBgOGcs",
  },
  {
    youtubeLink: "ZdewERLY1Is",
  },
  {
    youtubeLink: "1zNk7C9Zkz0",
  },
  {
    youtubeLink: "HafnU2Q7Xto",
  },
  {
    youtubeLink: "k5O-jB5VkOo",
  },
  {
    youtubeLink: "nYZGz4xX2ss",
  },
];

export default recipesVideoData;
